import * as Equal from 'effect/Equal';
import {useInsertionEffect, useRef} from 'react';

export function useEqualsMemo<T>(value: T, equals: (a: T, b: T) => boolean = Equal.equals): T {
    const ref = useRef(value);

    let next = ref.current;
    if (!equals(value, ref.current)) {
        next = value;
    }
    useInsertionEffect(() => {
        ref.current = next;
    });

    return next;
}
